<template>
    <tr class="lms__superadmin_customer_list_table_item">
        <td class="lms__superadmin_customer_list_table_item_name">{{customerName}}</td>
        <td class="lms__superadmin_customer_list_table_item_actions">
            <div class="columns is-inline-block is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :to="{ name: 'lms-superadmin-customer-edit', params: { id: customerId } }"
                        :name="`lms-superadmin-customer-list-table-item-actions-edit-${customerId}`"
                    >{{ $t('lms.customer.buttons.edit') }}
                    </component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'lms-superadmin-customer-list-table-item',
  components: { ComponentButton },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    customerId () {
      return this.item.id
    },
    customerName () {
      return this.item.name
    },
    customerWorkspaces () {
      return this.fromObjectToStringComma(this.item.workspaces, 'name')
    }
  }
}
</script>
